import { useCallback, useEffect, useRef } from 'react';

function buildResizeObserver(callback: (entries?: { contentRect: { height: number } }[]) => void) {
  if (typeof window.ResizeObserver === 'undefined') {
    const resizeCallback = () => callback();
    return {
      observe: () => window.addEventListener('resize', resizeCallback, { passive: true }),
      unobserve: () => window.removeEventListener('resize', resizeCallback),
    };
  }
  /* istanbul ignore next */
  return new ResizeObserver(callback);
}

const useNavbarHeightObserver = () => {
  const headerRef = useRef<HTMLDivElement>();

  const calculateHeight = useCallback((entries?: { contentRect: { height: number } }[]) => {
    const navbarHeight = entries ? entries[0].contentRect.height : headerRef.current.offsetHeight;
    if (navbarHeight) {
      document.body.style.setProperty('--navbar-height', `${navbarHeight}px`);
    }
  }, []);

  useEffect(() => {
    calculateHeight();
    const el = headerRef.current;
    const resizeObserver = buildResizeObserver(calculateHeight);
    resizeObserver.observe(el);
    return () => resizeObserver.unobserve(el);
  }, [calculateHeight]);

  return headerRef;
};

export default useNavbarHeightObserver;
